import { throttle } from '@/util'
import { wgs2gcj } from '@/util/map/proj'
import { createDict } from '@/util/dicts'
import { getPositionByCode } from '@/components/vue-sl/city-select'
import request from '@/util/request'

import CarDetail    from '../partial/car-detail'
import TrafficLayer from '../partial/traffic-layer'
import ClusterLayer from '../partial/car-layer/cluster'
import LiveLayer    from '../partial/car-layer/live'
import DataManager  from '../partial/car-layer/data'
import CarStats from '../partial/car-stats'

import { promiseZoom, promiseSetZoomAndCenter } from '../partial/utils'

import './index.scss'

import config from '../../../config'

const ACL = (subject) => {

}

const cache = {}

export default {
  props: ['defaultCompanyId', 'defaultZoom', 'defaultAreaCode', 'switchZoom', 'acl'],
  data() { //
    return {
      companies: [],
      componentStats: [],
      ready: false,
      map: null,
      liveLayer: null,
      visible: false,
      carStateStats: [],
      clusterLayer: null,
      visibleCount: false,
      visibleDetail: false,
      focusCarLocation:{},
      params: {
        companyId: null,
      },
      key: null
    }
  },
  beforeDestroy() {
    this.liveLayer.destroy()
    this.map.destroy()
  },
  created() {
    this.$watch('defaultAreaCode', function(nv) {
      console.log('defaultAreaCode', nv)
      this.changeCity(nv)
    })

    if(this.defaultCompanyId){
      this.params.companyId = this.defaultCompanyId
    }
  },
  computed: {
    switchZoomCalc() {
      if (this.params.companyId) {
        return 1
      } else {
        return this.switchZoom || 13
      }
    }
  },
  methods: {
    async init(map) {
      this.map = map

      this.clusterLayer = await ClusterLayer.create(map)
      this.liveLayer = new LiveLayer(map)
      this.dataHub = new DataManager(map , this.acl)

      this.clusterLayer.on('click', this.handleClusterClick.bind(this))
      this.liveLayer.on('click', this.handlePointClick.bind(this))
      this.dataHub.on('patch' , this.handlePatch.bind(this))

      this.map.on('zoomend', this.updateViewLayer.bind(this))

      let params = this.getBounds()

      if (this.params.companyId) params.companyIds = [parseInt(this.params.companyId)]

      let { data, stateStats } = await this.dataHub.fetch(params , createDict('carMixState'))

      this.carStateStats = stateStats

      this.clusterLayer.setData(data)

      this.data = data

      this.ready = true

      if (this.defaultCompanyId) {

      } else if (window.location.search) {
        let { lat, lng, zoom = 8 } = this.$route.query
        if (lat && lng) {
          setTimeout(() => {
            this.map.setZoomAndCenter(zoom, new AMap.LngLat(lng, lat))
          }, 800)
        }
      }

      let targetOptions = [this.map.getZoom(), this.map.getCenter()]
      if (this.defaultZoom) {
        targetOptions[0] = this.defaultZoom
      }
      if (this.defaultAreaCode) {
        let dst = getPositionByCode(this.defaultAreaCode)
        if (this.defaultAreaCode == '86') {
          targetOptions[0] = 5
          this.liveLayer.hide()
        }
        targetOptions[1] = new AMap.LngLat(dst[0], dst[1])
      }

      this.map.setZoomAndCenter(...targetOptions)
    },

    //更新视图
    updateViewLayer() {
      let zoom = this.map.getZoom()
      if (zoom > this.switchZoomCalc) {
        this.clusterLayer.hide()
        this.liveLayer.show()
        this.dataHub.watch()
      } else {
        this.clusterLayer.show()
        this.liveLayer.hide()
        this.dataHub.unwatch()
      }
    },

    handlePatch(e,data){
      this.liveLayer.setData(data)

      //检测
      if(this.focusCarNo){
        let { focusCarNo } = this
        let hit = data.find(i => i.carNo == focusCarNo)
        if( hit ){
          this.focusCarLocation = {latitude:hit.lat,longitude:hit.lng}
        }
      }
    },
    fetchBrand() {
      Promise.resolve(cache['brand'] || this.$request.brands(0)).then(resp => {
        if (resp.code == 0) {
          cache['brand'] = resp

          resp.data.forEach(i => {
            i.logo = getStaticPath(i.brandLogo)
          })
          this.brands = this.$utils.map(resp.data, 'id')
          this.ready = true
          this.fetchCompany()
        }
      })
    },
    async changeCity(areacode) {

      this.liveLayer.clear()
      this.handleCloseDetail()

      if (areacode == '86') {
        let dst = getPositionByCode(areacode)
        await promiseSetZoomAndCenter(this.map, 5, new AMap.LngLat(dst[0], dst[1]), 600)
        return
      }

      let c = this.map.getCenter()
      let dst = getPositionByCode(areacode)
      let nc = new AMap.LngLat(dst[0], dst[1])
      let mc = new AMap.LngLat(c.getLng() + (dst[0] - c.getLng()) * 0.618, c.getLat() + (dst[1] - c.getLat()) * 0.618)
      let targetZoom = this.defaultZoom || this.map.getZoom()
      this.animating = true
      this.liveLayer.hide()

      // this.fetch()

      await promiseSetZoomAndCenter(this.map, 6, mc, 1000)
      await promiseSetZoomAndCenter(this.map, targetZoom, nc, 600)
      this.animating = false

      await promiseZoom(this.map, targetZoom, 600)

    },
    async handleClusterClick(event, record) {
      if (record.feature.properties.level === "district") {

        await promiseSetZoomAndCenter(this.map, this.switchZoomCalc + 1, new AMap.LngLat(...record.feature.properties.center))

        let { carStateStats } = this

        let data = record.dataItems.map(i => {
          let { lat, lng, mixState, carNo, license, label,logo,companyName} = i.dataItem
     
          return {
            lat,
            lng,
            carNo,
            mixState,
            id: carNo,
            visible: carStateStats[mixState].visible,
            label,
            logo,
            companyName:companyName || ''
          }
        })

        this.liveLayer.setData(data)
      }

    },
    handlePointClick(e, data) {
      this.focusTo(data)
    },

    update() {
      if (this.ready) {
        this.liveLayer.update()
      }
    },

    getBounds() {
      let ret = {
        radius: this.defaultRadius || 10000000
      }
      if (this.defaultAreaCode) {
        let hit = getPositionByCode(this.defaultAreaCode)
        ret.lng = hit[0]
        ret.lat = hit[1]
      } else {
        let rate = 1.5
        let def = this.map.getBounds()
        let ne = def.getNorthEast()
        let c = def.getCenter()
        let r = c.distance(ne)

        ret.lng = c.getLng()
        ret.lat = c.getLat()
      }

      return ret
    },

    handleModal() {
      setTimeout(this.update, 1000)
    },
    handleToggle(i, idx) {
      let key = i.value

      i.visible = !i.visible

      this.liveLayer.setTypeState(key, i.visible)
      // this.fetch()

    },

    handleToggleCount() {
      this.visibleCount = !this.visibleCount
    },
    handleSearch() {
      if (this.key) {
        let key = this.key.toUpperCase()
        let hit = this.data.find(i => i.tags.includes(key))
        if (hit) {
          this.focusTo(hit)
        } else {
          this.$Message.error('没有搜索到车辆');
        }
      }
    },

    focusTo(d) {
      if (d === null) {
        this.focusCarNo = null
        this.focusCarLocation = null
        if (this.focusPollTimer) {
          window.clearTimeout(this.focusPollTimer)
        }
        this.liveLayer.focus(null)
        return
      }

      if (this.focusCarNo == d.carNo) {
        return
      }

      this.focusCarNo = this.key = d.carNo
      this.focusCarLocation = {latitude:d.lat,longitude:d.lng}

      //使用缓存数据定位
      if (d.lat && d.lng) {
        let position = new AMap.LngLat(d.lng, d.lat)
        let fitZoom = Math.max(this.map.getZoom(), 16)
        this.map.setZoomAndCenter(fitZoom, position)
        this.liveLayer.focus(d.carNo)
      }
    },

    handleCloseDetail() {
      this.key = null
      this.focusTo(null)
    },

    refresh() {

    }
  },
  render() {
    let selectNode = null
    let carStateStats = this.carStateStats || []

    return <div style="width:100%;height:100%;" class={{'car-map':1,'hide-count':(!this.visibleCount) ? 1 : null}}>
      <sl-amap class="map" view-mode="2D" theme="whitesmoke" zoom={4} on-ready={this.init} />
      <sl-amap-toolbar map={this.map} />
      <div class="car-map-control">
        <div class="car-map-control__header">
          <div class="car-map-control-search">
            <Input filterable={true} v-model={this.key} placeholder={this.ready ? '输入车辆编号/车牌号 回车搜索' :  '加载中' } nativeOn-keyup={arg => arg.keyCode === 13 && this.handleSearch() } />

            <div class="car-map-menu">
              {
                this.ready ? ( this.focusCarNo ? <Icon class="car-map-close" size="20" on-click={this.handleCloseDetail} type="md-close" /> : null) : <Icon size="20" class={{'car-map-control__refresh':true,'car-map-control__refresh--loading':1}} type="md-refresh"  />
              }
              <TrafficLayer map={this.map} />
              {/*<a title="显示企业统计" class={{'car-map-control__item':1,'active':this.visibleCount}} style="margin-left:5px;" on-click={this.handleToggleCount}>
                <Icon type="ios-stats" />
                <span>统计</span>
              </a>*/}
            </div>
          </div>
          {
            !this.focusCarNo ? <div class="car-map-stats">
              {
                carStateStats.map((i,idx) => (
                  <div class={{'car-map-stat':1,'disabled':!i.visible}} on-click={() => this.handleToggle(i,idx)}>
                    <div style="display:flex;align-items:center;justify-content: center;"><i style={{'borderColor':i.color}}></i>{i.count * (config.rate || 1)}辆</div>
                    <div>{i.label}</div>
                  </div>
                ))
              }
            </div> : null
          }
          
        </div>
        <CarDetail class="map-car-detail" style="margin-top:10px;" carNo={this.focusCarNo} location={this.focusCarLocation} />
      </div>
      {/* <CarStats /> */}
    </div>
  }
}